import { SaleOrderComponent } from "./components/sale-order/sale-order.component";
import { OrdersListingComponent } from "./components/orders-listing/orders-listing.component";
import { OrdersComponent } from "./orders.component";
import { OrderSummaryComponent } from "./components/order-summary/order-summary.component";
import { OrderLineItemComponent } from "./components/order-line-item/order-line-item.component";
import { FreightChargesComponent } from "./components/freight-charges/freight-charges.component";
import { PoEmailComponent } from "./components/po-email/po-email.component";
import { AllSalesListingComponent } from "./components/all-sales-listing/all-sales-listing.component";
import { Routes } from "@angular/router";
import { CanDeactivateGuard } from "../../core/guards/can-deactivate/can-deactivate.guard";
import { InventorySalesListingComponent } from "./components/inventory-sales-listing/inventory-sales-listing.component";
import { RefreshComponent } from "./components/refresh/refresh.component";

export const salesOrderRoutes: Routes = [
  { path: "", component: OrdersComponent },
  { path: "orders-listing", component: OrdersListingComponent },
  {
    path: "order-header",
    component: SaleOrderComponent,
  },
  {
    path: "order-line-item/:id",
    component: OrderLineItemComponent,
  },
  {
    path: "order-line-item/:id/:linenumber",
    component: OrderLineItemComponent,
  },
  {
    path: "order-summary/:id",
    component: OrderSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  { path: "freight-charges/:id", component: FreightChargesComponent },
  { path: "po-email/:id/:poNumber", component: PoEmailComponent },
  { path: "po-email/:id/:poNumber/:windowState", component: PoEmailComponent },
  {
    path: "orderslist/:isAdditionalFilters",
    component: OrdersComponent,
  },
  {
    path: "all-sales-listing",
    component: AllSalesListingComponent,
  },
  {
    path: "refresh-component",
    component: RefreshComponent,
  },
  {
    path: "inventory-sales-listing",
    component: InventorySalesListingComponent,
  },
];
